module.exports = __webpack_public_path__ + "img/kuaizhi.f071e0ef.png";